<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>{{ $t(`navigation.routeTitles.contact`) }}</h1>
        <p class="my-4">
          For inquiries about the GHG Calculator for Municipal Projects please
          contact us using the form below:
        </p>
        <ContactForm></ContactForm>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
useSeoMeta({
  description:
    "GHG Calculator for Municipal Projects - Contact",
  ogTitle: "Contact - GHG Calculator for Municipal Projects",
  ogDescription:
    "GHG Calculator for Municipal Projects - Contact",
  ogImage: "/images/ghg_calculator_icon_250.png",
  ogUrl: "https://ghg-calculator.ssg.coop",
  twitterTitle: "Contact - GHG Calculator for Municipal Projects",
  twitterDescription:
    "GHG Calculator for Municipal Projects - Contact",
  twitterImage: "/images/ghg_calculator_icon_250.png",
  twitterCard: "summary",
});

useHead({
  title: "Contact",
  htmlAttrs: {
    lang: "en",
  },
});
</script>
<style lang="scss">
@use "./settings";
</style>
